import React, { useState } from 'react';
import PanelHeader from '../PanelHeader';
import { useEditor } from '../EditorContext';
import { stickerUrl, isStickerObject } from '../fabricHelpers';
import { addStickerToCanvas, setObjectFill } from '../../canvasEditor';

export default function StickersPanel() {
  const { fabricRef, stickerCategories, selection, refreshLayers } = useEditor();
  const [openCat, setOpenCat] = useState(null);

  const isSticker = selection && isStickerObject(selection);
  const isSvgSticker = isSticker && (selection.imagetype === 'svg' || selection.type === 'group');

  const addSticker = async (category, index) => {
    const fc = fabricRef.current;
    if (!fc) return;
    try {
      await addStickerToCanvas(fc, category, index);
      refreshLayers?.();
    } catch (err) {
      console.warn('Sticker load failed', stickerUrl(category, index), err);
    }
  };

  const onOpacity = (e) => {
    if (!selection) return;
    selection.set('opacity', Number(e.target.value) / 100);
    fabricRef.current?.renderAll();
  };

  const onFill = (e) => {
    if (!selection) return;
    setObjectFill(selection, e.target.value);
    fabricRef.current?.renderAll();
  };

  return (
    <div className="pixie-panel">
      <PanelHeader title="Stickers" icon="fa-heart" />
      <div className="pixie-sticker-accordion">
        {stickerCategories.map((cat) => (
          <div key={cat.name} className="pixie-sticker-cat">
            <button
              type="button"
              className="pixie-sticker-cat-btn"
              onClick={() => setOpenCat(openCat === cat.name ? null : cat.name)}
            >
              {cat.name}
              <i className={`fa-solid fa-chevron-${openCat === cat.name ? 'up' : 'down'}`} />
            </button>
            {openCat === cat.name && (
              <div className="pixie-sticker-grid">
                {Array.from({ length: cat.items }, (_, i) => i + 1).map((index) => (
                  <button
                    key={index}
                    type="button"
                    className={`pixie-sticker-thumb ${cat.darkbg ? 'darkbg' : ''}`}
                    onClick={() => addSticker(cat, index)}
                    title={`${cat.name} ${index}`}
                  >
                    <img src={stickerUrl(cat, index)} alt="" loading="lazy" />
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {isSticker && (
        <div className="pixie-props">
          <label className="pixie-field">
            Opacity
            <input
              type="range"
              min={10}
              max={100}
              value={Math.round((selection.opacity ?? 0.9) * 100)}
              onChange={onOpacity}
            />
          </label>
          {isSvgSticker && (
            <label className="pixie-field">
              Fill color
              <input type="color" defaultValue="#000000" onChange={onFill} />
            </label>
          )}
        </div>
      )}
    </div>
  );
}
